import React from 'react';
import * as Sentry from '@sentry/nextjs';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import { isOnline } from '../../utils/environment';
import { Error } from './Error';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { hasError } = this.state;
        const { router } = this.props;

        // reset previous error when navigating
        if (hasError && nextProps.router.asPath !== router.asPath) {
            this.setState({
                hasError: false,
            });
        }
    }

    componentDidCatch(error) {
        this.setState({ hasError: true });
        Sentry.captureException(error);
    }

    render() {
        const { hasError } = this.state;
        const { errorComponent, router, children } = this.props;
        if (hasError) {
            const Component = errorComponent || Error;

            return <Component pathname={router.asPath} isNetworkOnline={isOnline()} />;
        }

        return children;
    }
}

ErrorBoundary.propTypes = {
    errorComponent: PropTypes.func,
    router: PropTypes.object,
};

export default withRouter(ErrorBoundary);
